import * as React from 'react';
function IconContact(props) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h24v24H0z" }),
            React.createElement("path", { d: "M7 21c0-.46.344-1.515.88-2.321C8.596 17.604 9.549 17 10.784 17h2.434c1.235 0 2.188.604 2.902 1.679.537.806.881 1.86.881 2.321h2c0-2.584-2.27-6-5.783-6h-2.434C7.271 15 5 18.416 5 21h2zM17 8A5 5 0 107 8a5 5 0 0010 0zm-2 0a3 3 0 11-6 0 3 3 0 016 0z", fill: "currentColor", fillRule: "nonzero" }))));
}
export default IconContact;
//# sourceMappingURL=IconContact.js.map